import React, { CSSProperties, FC } from 'react';

import { cn } from '../../../../utils';

type OwnProps = {
  size?: number;
  color?: string;
  strokeWidth?: number;
  className?: string;
  style?: CSSProperties;
  title?: string;
};

type Props = OwnProps & Omit<React.SVGProps<SVGSVGElement>, keyof OwnProps | 'color'>;

const SettingsIcon: FC<Props> = ({
  size = 24,
  color = 'var(--gray-color-3)',
  strokeWidth = 1.5,
  className,
  style,
  title = 'Настройки',
  ...svgProps
}) => (
  <svg
    className={cn(className)}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label={title}
    style={{ width: size, height: size, color, ...style }}
    {...svgProps}
  >
    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth={strokeWidth} />
    <path
      d="M12 2.5a1.7 1.7 0 0 1 1.7 1.7v.3a1.7 1.7 0 0 0 2.9 1.2l.2-.2a1.7 1.7 0 1 1 2.4 2.4l-.2.2a1.7 1.7 0 0 0 1.2 2.9h.3a1.7 1.7 0 0 1 0 3.4h-.3a1.7 1.7 0 0 0-1.2 2.9l.2.2a1.7 1.7 0 1 1-2.4 2.4l-.2-.2a1.7 1.7 0 0 0-2.9 1.2v.3a1.7 1.7 0 0 1-3.4 0v-.3a1.7 1.7 0 0 0-2.9-1.2l-.2.2a1.7 1.7 0 1 1-2.4-2.4l.2-.2a1.7 1.7 0 0 0-1.2-2.9h-.3a1.7 1.7 0 0 1 0-3.4h.3a1.7 1.7 0 0 0 1.2-2.9l-.2-.2a1.7 1.7 0 1 1 2.4-2.4l.2.2a1.7 1.7 0 0 0 2.9-1.2v-.3A1.7 1.7 0 0 1 12 2.5Z"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SettingsIcon;
